import { api } from './client';

export const billingApi = {
  // ADR-0023: the web sells PRO through Stripe; the apps through their store.
  createProCheckout: () =>
    api.post<{ url: string }>('/billing/pro/checkout').then(r => r.data),
  /** Stripe's own page to cancel, change the card or see invoices. */
  openPortal: () =>
    api.post<{ url: string }>('/billing/portal').then(r => r.data),
};
